
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill":"#062521","fill-rule":"evenodd","d":"M18.01 27.673V16.875h3.638l.544-4.209H18.01V9.98c0-1.218.34-2.048 2.094-2.048l2.237-.001V4.166C21.953 4.115 20.625 4 19.08 4c-3.225 0-5.433 1.961-5.433 5.563v3.103H10v4.209h3.647v10.798h4.362z"}})])
      }
    
      }
    